export default __webpack_public_path__ + "static/media/c3.9065ac8c.svg";